import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Segment, SegmentState} from './segment.model';
import {SegmentFacadeService} from './segment-facade.service';

@Injectable({
  providedIn: 'root'
})
export class ParentSegmentsStateProxyService {

  private parentCandidates = new Subject<Segment[]>();

  constructor(private facade: SegmentFacadeService) {
  }

  getCandidates() {
    return this.parentCandidates.asObservable();
  }

  findCandidates() {
    this.facade.loadSegmentsForCreationOrEdit({
      state: SegmentState.ACTIVE,
    });
  }

  candidatesChanged(segments: Segment[]) {
    this.parentCandidates.next(segments);
  }
}
